module.exports = __webpack_public_path__ + "static/media/icon-plus-white.9fff512f.svg";